import { TradingViewWidget } from "components";
import { useGetPriceChartProperty } from "../services/AnalyticsPageService";
import storage from "services/storage";

const PriceChartSection = () => {
  const companyIdLocalStorage = storage.getCompanyID();

  const { response } = useGetPriceChartProperty({ id: companyIdLocalStorage });

  return (
    <div className='section h-[807px]'>
      <p className='text-[#5F737F] mb-5'>Price History Chart</p>
      <div className='h-[707px]'>
        <TradingViewWidget data={response?.data} />
      </div>
    </div>
  );
};

export default PriceChartSection;
